import React from "react";
import InformationCard from "../../../../../elements/InformationCard";

interface ITextSentimentModelOutputState {
    sentimentAnalysis: any;
    errorMessage: string;
}

class TextSentimentModelOutput extends React.Component<{}, ITextSentimentModelOutputState> {
    public SENTIMENT_OPTIONS = ['Positive', 'Negative', 'Neutral'];

    constructor(props: {}) {
        super(props);
        this.state = {
            sentimentAnalysis: [],
            errorMessage: ""
        };
    }

    public processResponse = (response: any) => {
        if (response && response.SentimentScore) {
            const result: any = [];
            response.SentimentScore.forEach((score: any) => {
                Object.keys(score).forEach((key) => {
                    if (this.SENTIMENT_OPTIONS.indexOf(key) !== -1) {
                        result.push({
                            key,
                            score: score[key]
                        });
                    }
                });
            });
            this.setState({sentimentAnalysis: result});
        } else {
            this.setState({errorMessage: "Couldn't get sentiment."});
        }
    };

    public render() {
        return (
            <React.Fragment>
                {
                    this.state.sentimentAnalysis.length ? <InformationCard>
                        {
                            this.state.sentimentAnalysis.map((item: any) => {
                                return <div key={item.key}>{item.key} - {item.score}%</div>
                            })
                        }
                    </InformationCard> : <></>
                }
                {
                    this.state.errorMessage ? <InformationCard>{this.state.errorMessage}</InformationCard> : <></>
                }
            </React.Fragment>
        );
    }
}

export default TextSentimentModelOutput;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/output/TextSentiment/TextSentimentModelOutput.tsx